import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Row from 'components/Layout/Row';

type Props = {
  isExpanded?: boolean;
  onToggleExpanded: () => void;
  title: string;
  customActions?: React.ReactNode;
};

const SectionHeader: React.FC<Props> = ({
  onToggleExpanded,
  isExpanded,
  title,
  customActions,
}) => {
  return (
    <Row centered fullWidth justify="space-between">
      <Typography variant="h5">{title}</Typography>
      <Row spacing="md">
        {customActions ?? null}
        <IconButton onClick={onToggleExpanded}>
          {isExpanded ? (
            <ExpandLess fontSize="small" />
          ) : (
            <ExpandMore fontSize="small" />
          )}
        </IconButton>
      </Row>
    </Row>
  );
};

export default SectionHeader;
